/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBFREQUENCY = {
    Yearly: '1',
    HalfYearly: '2',
    Quarterly: '4',
    Monthly: '12',
    Single: '0'
} as const;
export type GHUBFREQUENCY = typeof GHUBFREQUENCY[keyof typeof GHUBFREQUENCY];


export function GHUBFREQUENCYFromJSON(json: any): GHUBFREQUENCY {
    return GHUBFREQUENCYFromJSONTyped(json, false);
}

export function GHUBFREQUENCYFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBFREQUENCY {
    return json as GHUBFREQUENCY;
}

export function GHUBFREQUENCYToJSON(value?: GHUBFREQUENCY | null): any {
    return value as any;
}

